import React from "react";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import WarningIcon from "@material-ui/icons/Warning";

function Result({ text, variant }) {
  let IconComponent;
  let color;

  switch (variant) {
    case "success":
      IconComponent = CheckCircleIcon;
      color = "!fill-green-500";
      break;
    case "error":
      IconComponent = ErrorIcon;
      color = "!fill-red-500";
      break;
    case "warning":
      IconComponent = WarningIcon;
      color = "!fill-yellow-500";
      break;
    default:
      IconComponent = ErrorIcon;
      color = "!fill-red-500";
      break;
  }

  return (
    <div className="flex row-auto flex-row mb-4">
      <IconComponent className={`${color} mr-2`} />
      <p className="text-md font-normal text-gray-800">{text}</p>
    </div>
  );
}

export default Result;
